export * from './ov-generic.module';
export * from './ov-generic.routing';
export * from './ov-generic.types';
export * from './add-or-edit/ov-generic-add-or-edit.component';
export * from './list/ov-generic-list.component';
